import React from "react";
import { Container } from "@mui/material";
import OffreTemplate from "../components/OffreTemplate";
import SEO from "../components/SEO";
import SeoInternalLinks from "../components/SeoInternalLinks";
import exampleApp1 from "../assets/images/projets/leco-franceMob.png";
import exampleApp2 from "../assets/images/projets/hexagoneMobile.png";
import imgMobile1 from "../assets/images/imgMobile1.png";
import imgMobile2 from "../assets/images/imgMobile2.png";
import imgMobile3 from "../assets/images/imgMobile3.png";
import imgMobile4 from "../assets/images/imgMobile4.png";

export default function OffreMobilePage() {
  return (
    <>
      <SEO
        title="Développement d'application mobile sur mesure | DigiBuddy"
        description="Développement d'applications mobiles sur mesure iOS et Android pour PME et startups : conception, publication sur les stores et évolutions."
        keywords="développement application mobile, application mobile sur mesure, développeur mobile freelance, application iOS Android, MVP mobile, application métier mobile"
        url="https://www.digibuddy.fr/developpement-application-mobile"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Applications Mobiles sur Mesure",
          description:
            "Applications mobiles natives et hybrides qui convertissent. iOS, Android, PWA.",
          provider: {
            "@type": "Organization",
            name: "DigiBuddy",
          },
          areaServed: "FR",
          serviceType: "Développement mobile",
          offers: {
            "@type": "Offer",
            price: "À partir de 5000€",
            priceCurrency: "EUR",
          },
        }}
      />
      <OffreTemplate
        title="Applications mobiles qui convertissent"
        intro="<b>Transformez votre business avec une app mobile<br>qui engage vos clients et booste vos ventes.</b><br><br>Vos clients vous emportent partout avec eux, dans leur poche."
        bannerImage="/images/banner-mobile.jpg"
        url="https://www.digibuddy.fr/developpement-application-mobile"
        sections={[
          {
            title: "Apps qui vendent",
            subtitle: "Vos clients achètent depuis leur mobile",
            paragraph:
              "Nous créons des applications mobiles qui ne se contentent pas d'être jolies, mais qui génèrent réellement des ventes et engagent vos clients.",
            bullets: [
              "Applications e-commerce qui convertissent",
              "Apps de fidélisation et gamification",
              "Applications de réservation et prise de RDV",
              "Apps métier pour vos équipes",
            ],
            imageSrc: imgMobile1,
          },
          {
            title: "Expérience utilisateur exceptionnelle",
            subtitle: "Vos clients adorent utiliser votre app",
            paragraph:
              "Une app mobile doit être intuitive, rapide et agréable à utiliser. Nous créons des expériences qui fidélisent vos clients et les font revenir.",
            bullets: [
              "Interface intuitive et navigation fluide",
              "Design moderne et animations élégantes",
              "Performance optimisée et chargement rapide",
              "Fonctionnement hors ligne quand possible",
            ],
            imageSrc: imgMobile2,
          },
          {
            title: "Fonctionnalités qui engagent",
            subtitle: "Gardez vos clients connectés",
            paragraph:
              "Nous intégrons les fonctionnalités modernes qui engagent vos utilisateurs : notifications push, géolocalisation, paiements sécurisés, et bien plus.",
            bullets: [
              "Notifications push pour rester en contact",
              "Géolocalisation et services de proximité",
              "Paiements sécurisés intégrés",
              "Synchronisation avec vos systèmes existants",
            ],
            imageSrc: imgMobile3,
          },
          {
            title: "Publication et croissance",
            subtitle: "De la conception au succès sur les stores",
            paragraph:
              "Nous vous accompagnons dans toute la chaîne : développement, tests, publication sur les stores, et stratégie de croissance pour maximiser les téléchargements.",
            bullets: [
              "Publication sur App Store et Google Play",
              "Optimisation pour les stores (ASO)",
              "Stratégie de croissance et marketing",
              "Maintenance et mises à jour régulières",
            ],
            imageSrc: imgMobile4,
          },
        ]}
        galleryImages={[exampleApp1, exampleApp2]}
      />
      <Container sx={{ py: 2 }} style={{ maxWidth: "800px" }}>
        <SeoInternalLinks
          title="À lire aussi"
          links={[
            { to: "/creation-site-web-sur-mesure", label: "Création de site web sur mesure" },
            { to: "/combien-coute-site-web-sur-mesure", label: "Combien coûte un site web sur mesure ?" },
            { to: "/freelance-ou-agence-pour-creer-son-site", label: "Freelance ou agence ?" },
            { to: "/", label: "Accueil" },
          ]}
        />
      </Container>
    </>
  );
}
